module.exports = __webpack_public_path__ + "img/gift.e0f6f10.svg";